const toastMessages = {
  'toast.message.tag.import': 'タグをインポートしました。',
  'toast.message.tag.update': 'タグを更新しました。',
  'toast.message.tag.delete': 'タグを削除しました。',
  'toast.message.tag.restore': '削除したタグを元に戻しました。',
};

export default toastMessages;
